export const getRemovedUnusedParams = (params = {}) => {
  const copiedParams = { ...params };
  for (let p in copiedParams) {
    if (!copiedParams[p] && copiedParams[p] !== 0 && copiedParams[p] !== false) {
      delete copiedParams[p];
    }
  }
  return copiedParams;
};
